import DefaultHeadings from "../enums/TextTemplateTypes";
import Flags from "../other/Flags";

export const ResourceGroups = [
  // BEWERBER
  // BEWERBER
  // BEWERBER
  {
    name: "Bewerber",
    resources: [
      {
        name: "Verfügbarkeit",
        overviewQuery: "applicantAvailibilities",
        singleQuery: "applicantAvailibility",
        inputDataType: "ApplicantAvailibilityInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Formel", name: "formular" }
        ]
      },
      {
        name: "Zertifizierungen",
        overviewQuery: "applicantCertificateAreas",
        singleQuery: "applicantCertificateArea"
      },
      {
        name: "Branchen - Lebenslauf Einträge",
        overviewQuery: "applicantCvEntryBranches",
        singleQuery: "applicantCvEntryBranch"
      },
      {
        name: "Löschgründe",
        overviewQuery: "applicantDeleteReasons",
        singleQuery: "applicantDeleteReason"
      },
      {
        name: "Führerscheine",
        overviewQuery: "applicantDriverLicenses",
        singleQuery: "applicantDriverLicense",
        inputDataType: "ApplicantDriverLicenseInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          {
            label: "Art",
            name: "type",
            required: true,
            type: "select",
            options: [
              { label: "Neu", code: "NEW" },
              { label: "Alt", code: "OLD" },
              { label: "Sehr alt", code: "VERYOLD" }
            ]
          }
        ]
      },
      {
        name: "Berufserfahrung",
        overviewQuery: "applicantJobExperiences",
        singleQuery: "applicantJobExperience",
        fields: [{ label: "Bezeichung", name: "name", required: true }]
      },
      {
        name: "Eingangsart",
        overviewQuery: "applicantEntryTypes",
        singleQuery: "applicantEntryType"
      },
      {
        name: "Gruppen",
        overviewQuery: "applicantGroups",
        singleQuery: "applicantGroup",
        inputDataType: "ApplicantGroupInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Aktiv", name: "active", type: "bool" }
        ]
      },
      {
        name: "Mobilität",
        overviewQuery: "applicantMobilities",
        singleQuery: "applicantMobility"
      },
      {
        name: "Berufskategorien",
        overviewQuery: "applicantSkillJobTypes",
        singleQuery: "applicantSkillJobType",
        inputDataType: "ApplicantSkillJobTypeInput",
        fields: [
          { label: "Bezeichnung", name: "name", required: true },
          {
            label: "In Statistik auswerten",
            name: "evaluateInStatistics",
            type: "bool"
          }
        ]
      },
      {
        name: "Quellen",
        overviewQuery: "applicantSources",
        singleQuery: "applicantSource"
      },
      {
        name: "Status",
        overviewQuery: "applicantStates",
        singleQuery: "applicantState"
      }
    ]
  },
  // FIRMEN
  // FIRMEN
  // FIRMEN
  {
    name: "Firmen",
    resources: [
      {
        name: "Kontakt Arten",
        overviewQuery: "companyContactTypes",
        singleQuery: "companyContactType"
      },
      {
        name: "Mitarbeiter Anzahl",
        overviewQuery: "companyEmployeeAmounts",
        singleQuery: "companyEmployeeAmount"
      },
      {
        name: "Status",
        overviewQuery: "companyStates",
        singleQuery: "companyState"
      },
      {
        name: "Zielgruppe",
        overviewQuery: "companyTargets",
        singleQuery: "companyTarget"
      },
      {
        name: "Branchen",
        overviewQuery: "sectors",
        singleQuery: "sector"
      }
    ]
  },
  // STELLEN
  // STELLEN
  // STELLEN
  {
    name: "Stellen",
    resources: [
      {
        name: "Bewerber Status",
        overviewQuery: "vacancyApplicantStates",
        singleQuery: "vacancyApplicantState",
        inputDataType: "VacancyApplicantStateInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Farbe (Hex - z.B. #00FF00)", name: "color", required: true }
        ]
      },
      {
        name: "Löschgründe",
        overviewQuery: "vacancyCloseReasons",
        singleQuery: "vacancyCloseReason"
      },
      {
        name: "Stellenportale",
        overviewQuery: "vacancyJobPlatforms",
        singleQuery: "vacancyJobPlatform"
      },
      {
        name: "Arbeitszeiten",
        overviewQuery: "vacancyJobTimes",
        singleQuery: "vacancyJobTime"
      },
      {
        name: "Art",
        overviewQuery: "vacancyJobTypes",
        singleQuery: "vacancyJobType"
      },
      {
        name: "Benefits",
        overviewQuery: "occupationBenefits",
        singleQuery: "occupationBenefit",
        inputDataType: "OccupationBenefitInput",
        fields: [
          { label: "Bezeichnung", name: "name", required: true },
          {
            label: "Text",
            name: "text",
            type: "html"
          }
        ]
      },
      {
        name: "Phase",
        overviewQuery: "vacancyPhases",
        singleQuery: "vacancyPhase"
      },
      {
        name: "Status",
        overviewQuery: "vacancyStates",
        singleQuery: "vacancyState"
      },
      /*{
        name: "Stellen - Vorlagen",
        overviewQuery: "vacancyTemplates",
        singleQuery: "vacancyTemplate"
      },*/
      {
        name: "Vorlagen",
        overviewQuery: "vacancyTemplateTypes",
        singleQuery: "vacancyTemplateType",
        inputDataType: "VacancyTemplateTypeInput",
        fields: [
          { label: "Bezeichnung", name: "name", required: true },
          {
            label: "FirmenProfil - Überschrift",
            name: "companyProfileHeading",
            default: DefaultHeadings.COMPANY_DESCRIPTION
          },
          {
            label: "FirmenProfil - Text",
            name: "companyProfileText",
            type: "html"
          },
          {
            label: "Kundenbeschreibung - Überschrift",
            name: "jobCustomerDetailsHeading",
            default: DefaultHeadings.CUSTOMER_DESCRIPTION
          },
          {
            label: "Kundenbeschreibung - Text",
            name: "jobCustomerDetailsText",
            type: "html"
          },
          {
            label: "Tätigkeit - Überschrift",
            name: "jobActivitiesHeading",
            default: DefaultHeadings.ACTIVITIES
          },
          {
            label: "Tätigkeit - Text",
            name: "jobActivitiesText",
            type: "html"
          },
          {
            label: "Profil - Überschrift",
            name: "jobProfilesHeading",
            default: DefaultHeadings.PROFILE
          },
          { label: "Profil - Text", name: "jobProfilesText", type: "html" },
          {
            label: "Perspektiven - Überschrift",
            name: "jobPerspectiveHeading",
            default: DefaultHeadings.PERSPECTIVES
          },
          {
            label: "Perspektiven - Text",
            name: "jobPerspectiveText",
            type: "html"
          },
          {
            label: "Abbinder - Überschrift",
            name: "jobFooterHeading",
            default: DefaultHeadings.FOOTER
          },
          { label: "Abbinder - Text", name: "jobFooterText", type: "html" }
        ]
      },
      {
        name: "Textvorlagen",
        overviewQuery: "vacancyTextTemplates",
        singleQuery: "vacancyTextTemplate",
        inputDataType: "VacancyTextTemplateInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Text", name: "text", type: "html", required: true },
          {
            label: "Art",
            name: "type",
            required: true,
            type: "select",
            options: [
              { label: "Firmen Profil", code: "COMPANY_DESCRIPTION" },
              { label: "Kundenbeschreibung", code: "CUSTOMER_DESCRIPTION" },
              { label: "Tätigkeiten", code: "ACTIVITIES" },
              { label: "Profil", code: "PROFILE" },
              { label: "Perspektiven", code: "PERSPECTIVES" },
              { label: "Abbinder", code: "FOOTER" }
            ]
          }
        ]
      },
      {
        name: "Berufskategorien",
        overviewQuery: "occupationCategories",
        singleQuery: "occupationCategory",
        fields: [{ label: "Bezeichung", name: "name", required: true }]
      },
      {
        name: "Benutzer Rollen",
        overviewQuery: "userRoles",
        singleQuery: "userRole",
        inputDataType: "UserRoleInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Schlüssel (keine Sonder- oder Leerzeichen)", name: "key" },
          {
            label: "Berechtigungen",
            name: "permissions{name, id}",
            required: true,
            type: "model",
            multiple: true,
            gqlQuery: "userPermissions"
          }
        ]
      }
    ]
  },
  // BERUFE
  // BERUFE
  // BERUFE
  {
    name: "Berufe",
    resources: [
      {
        name: "Berufe",
        overviewQuery: "occupations",
        singleQuery: "occupation",
        inputDataType: "OccupationInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          {
            label: "Kategorie",
            name: "category{name id}",
            required: true,
            type: "model",
            gqlQuery: "occupationCategories",
            inputName: "category"
          }
        ]
      },
      {
        name: "Berufskategorien",
        overviewQuery: "occupationCategories",
        singleQuery: "occupationCategory",
        fields: [{ label: "Bezeichung", name: "name", required: true }]
      }
    ]
  },
  // Dokumente
  // Dokumente
  // Dokumente
  {
    name: "Dokumente",
    resources: [
      {
        name: "Dokumentenvorlagen",
        overviewQuery: "documentPresets",
        singleQuery: "documentPreset",
        inputDataType: "DocumentPresetInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Betreff", name: "subject", required: true },
          { label: "Inhalt", name: "content", type: "html", required: true },
          {
            label: "Art",
            name: "type",
            required: true,
            type: "select",
            options: [
              { label: "Bewerber", code: "APPLICANT" },
              { label: "Projekt", code: "PROJECT" },
              { label: "Firma", code: "COMPANY" },
              { label: "Akquise", code: "ACQUISITION" }
            ]
          }
        ]
      },
      {
        name: "Dokumenten Arten",
        overviewQuery: "documentTypes",
        singleQuery: "documentType"
      }
    ]
  },
  // SONSTIGES
  // SONSTIGES
  // SONSTIGES
  {
    name: "Sonstiges",
    resources: [
      {
        name: "Abteilungen",
        overviewQuery: "departments",
        singleQuery: "department",
        inputDataType: "DepartmentInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Standort", name: "branchOffice" },
          { label: "Telefonnummer", name: "telephone" },
          { label: "E-Mail", name: "email" }
        ]
      },
      {
        name: "Aktionen (Historie/Wiedervorlagen)",
        overviewQuery: "actionTypes",
        singleQuery: "actionType",
        inputDataType: "ActionTypeInput",
        tableNameFunc: e =>
          `${e.nameResubmission || "-"}/${e.nameHistory || "-"}`,
        fields: [
          { label: "Bezeichung Historie", name: "nameHistory", required: true },
          {
            label: "Bezeichung Wiedervorlage",
            name: "nameResubmission",
            required: true
          },
          {
            label: "Verfügbar in",
            name: "availableFor",
            required: true,
            type: "select",
            options: [
              { label: "Alle", code: "ALL" },
              { label: "Stelle/Projekt", code: "VACANCY" },
              { label: "Firma", code: "COMPANY" },
              { label: "Bewerber", code: "APPLICANT" }
            ]
          }
        ]
      },
      {
        name: "Benutzer Rollen",
        overviewQuery: "userRoles",
        singleQuery: "userRole",
        inputDataType: "UserRoleInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Schlüssel (keine Sonder- oder Leerzeichen)", name: "key" },
          {
            label: "Berechtigungen",
            name: "permissions{name, id}",
            required: true,
            type: "model",
            multiple: true,
            gqlQuery: "userPermissions"
          }
        ]
      },
      {
        name: "Benutzer Gruppen",
        overviewQuery: "userGroups",
        singleQuery: "userGroup",
        inputDataType: "UserGroupInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          { label: "Aktiv", name: "active", type: "bool" },
          {
            label: "Agentur für Arbeit Kundennummer",
            name: "bACustomerNumber"
          },
          { label: "L1 Filialnummmer", name: "l1Filiale" },
          { label: "Email", name: "email" }
        ]
      },
      {
        name: "QR-Code Ausprägungen",
        overviewQuery: "qrCodeVariants",
        singleQuery: "qrCodeVariant",
        inputDataType: "QrCodeVariantInput",
        fields: [{ label: "Bezeichung", name: "name", required: true }]
      },
      {
        name: "Sprachen",
        overviewQuery: "languages",
        singleQuery: "language",
        inputDataType: "LanguageInput",
        fields: [
          { label: "Bezeichung", name: "name", required: true },
          {
            label: "Flagge",
            name: "emoji",
            required: false,
            type: "select",
            options: Flags
          }
        ]
      }
    ]
  }
];

export const Resources = [
  // {
  //   name: "Bewerber - Verfügbarkeit",
  //   overviewQuery: "applicantAvailibilities",
  //   singleQuery: "applicantAvailibility",
  //   inputDataType: "ApplicantAvailibilityInput",
  //   group: "Bewerber",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Formel", name: "formular" }
  //   ]
  // },
  // {
  //   name: "Bewerber - Zertifizierungen",
  //   overviewQuery: "applicantCertificateAreas",
  //   singleQuery: "applicantCertificateArea"
  // },
  // {
  //   name: "Bewerber - Branchen - Lebenslauf Einträge",
  //   overviewQuery: "applicantCvEntryBranches",
  //   singleQuery: "applicantCvEntryBranch"
  // },
  // {
  //   name: "Bewerber - Löschgründe",
  //   overviewQuery: "applicantDeleteReasons",
  //   singleQuery: "applicantDeleteReason"
  // },
  // {
  //   name: "Bewerber - Führerscheine",
  //   overviewQuery: "applicantDriverLicenses",
  //   singleQuery: "applicantDriverLicense",
  //   inputDataType: "ApplicantDriverLicenseInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     {
  //       label: "Art",
  //       name: "type",
  //       required: true,
  //       type: "select",
  //       options: [
  //         { label: "Neu", code: "NEW" },
  //         { label: "Alt", code: "OLD" },
  //         { label: "Sehr alt", code: "VERYOLD" }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: "Bewerber - Berufserfahrung",
  //   overviewQuery: "applicantJobExperiences",
  //   singleQuery: "applicantJobExperience",
  //   fields: [{ label: "Bezeichung", name: "name", required: true }]
  // },
  // {
  //   name: "Bewerber - Eingangsart",
  //   overviewQuery: "applicantEntryTypes",
  //   singleQuery: "applicantEntryType"
  // },
  // {
  //   name: "Bewerber - Gruppen",
  //   overviewQuery: "applicantGroups",
  //   singleQuery: "applicantGroup",
  //   inputDataType: "ApplicantGroupInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Aktiv", name: "active", type: "bool" }
  //   ]
  // },
  // {
  //   name: "Bewerber - Mobilität",
  //   overviewQuery: "applicantMobilities",
  //   singleQuery: "applicantMobility"
  // },
  // {
  //   name: "Bewerber - Berufskategorien",
  //   overviewQuery: "applicantSkillJobTypes",
  //   singleQuery: "applicantSkillJobType",
  //   inputDataType: "ApplicantSkillJobTypeInput",
  //   fields: [
  //     { label: "Bezeichnung", name: "name", required: true },
  //     {
  //       label: "In Statistik auswerten",
  //       name: "evaluateInStatistics",
  //       type: "bool"
  //     }
  //   ]
  // },
  // {
  //   name: "Bewerber - Quellen",
  //   overviewQuery: "applicantSources",
  //   singleQuery: "applicantSource"
  // },
  // {
  //   name: "Bewerber - Status",
  //   overviewQuery: "applicantStates",
  //   singleQuery: "applicantState"
  // },
  // {
  //   name: "Firmen - Kontakt Arten",
  //   overviewQuery: "companyContactTypes",
  //   singleQuery: "companyContactType"
  // },
  // {
  //   name: "Firmen - Mitarbeiter Anzahl",
  //   overviewQuery: "companyEmployeeAmounts",
  //   singleQuery: "companyEmployeeAmount"
  // },
  // {
  //   name: "Firmen - Status",
  //   overviewQuery: "companyStates",
  //   singleQuery: "companyState"
  // },
  // {
  //   name: "Firmen - Zielgruppe",
  //   overviewQuery: "companyTargets",
  //   singleQuery: "companyTarget"
  // },
  // {
  //   name: "Firmen - Branchen",
  //   overviewQuery: "sectors",
  //   singleQuery: "sector"
  // },
  // {
  //   name: "Berufe",
  //   overviewQuery: "occupations",
  //   singleQuery: "occupation",
  //   inputDataType: "OccupationInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     {
  //       label: "Kategorie",
  //       name: "category{name}",
  //       required: true,
  //       type: "model",
  //       gqlQuery: "occupationCategories",
  //       inputName: "category"
  //     }
  //   ]
  // },
  // {
  //   name: "Berufskategorien",
  //   overviewQuery: "occupationCategories",
  //   singleQuery: "occupationCategory",
  //   fields: [{ label: "Bezeichung", name: "name", required: true }]
  // },
  // {
  //   name: "Stellen - Bewerber Status",
  //   overviewQuery: "vacancyApplicantStates",
  //   singleQuery: "vacancyApplicantState",
  //   inputDataType: "VacancyApplicantStateInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Farbe (Hex - z.B. #00FF00)", name: "color", required: true }
  //   ]
  // },
  // {
  //   name: "Stellen - Löschgründe",
  //   overviewQuery: "vacancyCloseReasons",
  //   singleQuery: "vacancyCloseReason"
  // },
  // {
  //   name: "Stellen - Stellenportale",
  //   overviewQuery: "vacancyJobPlatforms",
  //   singleQuery: "vacancyJobPlatform"
  // },
  // {
  //   name: "Stellen - Arbeitszeiten",
  //   overviewQuery: "vacancyJobTimes",
  //   singleQuery: "vacancyJobTime"
  // },
  // {
  //   name: "Stellen - Art",
  //   overviewQuery: "vacancyJobTypes",
  //   singleQuery: "vacancyJobType"
  // },
  // {
  //   name: "Stellen - Benefits",
  //   overviewQuery: "occupationBenefits",
  //   singleQuery: "occupationBenefit",
  //   inputDataType: "OccupationBenefitInput",
  //   fields: [
  //     { label: "Bezeichnung", name: "name", required: true },
  //     {
  //       label: "Text",
  //       name: "text",
  //       type: "html"
  //     }
  //   ]
  // },
  // {
  //   name: "Stellen - Phase",
  //   overviewQuery: "vacancyPhases",
  //   singleQuery: "vacancyPhase"
  // },
  // {
  //   name: "Stellen - Status",
  //   overviewQuery: "vacancyStates",
  //   singleQuery: "vacancyState"
  // },
  // /*{
  //   name: "Stellen - Vorlagen",
  //   overviewQuery: "vacancyTemplates",
  //   singleQuery: "vacancyTemplate"
  // },*/
  // {
  //   name: "Stellen - Vorlagen",
  //   overviewQuery: "vacancyTemplateTypes",
  //   singleQuery: "vacancyTemplateType",
  //   inputDataType: "VacancyTemplateTypeInput",
  //   fields: [
  //     { label: "Bezeichnung", name: "name", required: true },
  //     {
  //       label: "FirmenProfil - Überschrift",
  //       name: "companyProfileHeading",
  //       default: DefaultHeadings.COMPANY_DESCRIPTION
  //     },
  //     {
  //       label: "FirmenProfil - Text",
  //       name: "companyProfileText",
  //       type: "html"
  //     },
  //     {
  //       label: "Kundenbeschreibung - Überschrift",
  //       name: "jobCustomerDetailsHeading",
  //       default: DefaultHeadings.CUSTOMER_DESCRIPTION
  //     },
  //     {
  //       label: "Kundenbeschreibung - Text",
  //       name: "jobCustomerDetailsText",
  //       type: "html"
  //     },
  //     {
  //       label: "Tätigkeit - Überschrift",
  //       name: "jobActivitiesHeading",
  //       default: DefaultHeadings.ACTIVITIES
  //     },
  //     { label: "Tätigkeit - Text", name: "jobActivitiesText", type: "html" },
  //     {
  //       label: "Profil - Überschrift",
  //       name: "jobProfilesHeading",
  //       default: DefaultHeadings.PROFILE
  //     },
  //     { label: "Profil - Text", name: "jobProfilesText", type: "html" },
  //     {
  //       label: "Perspektiven - Überschrift",
  //       name: "jobPerspectiveHeading",
  //       default: DefaultHeadings.PERSPECTIVES
  //     },
  //     {
  //       label: "Perspektiven - Text",
  //       name: "jobPerspectiveText",
  //       type: "html"
  //     },
  //     {
  //       label: "Abbinder - Überschrift",
  //       name: "jobFooterHeading",
  //       default: DefaultHeadings.FOOTER
  //     },
  //     { label: "Abbinder - Text", name: "jobFooterText", type: "html" }
  //   ]
  // },
  // {
  //   name: "Stellen - Textvorlagen",
  //   overviewQuery: "vacancyTextTemplates",
  //   singleQuery: "vacancyTextTemplate",
  //   inputDataType: "VacancyTextTemplateInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Text", name: "text", type: "html", required: true },
  //     {
  //       label: "Art",
  //       name: "type",
  //       required: true,
  //       type: "select",
  //       options: [
  //         { label: "Firmen Profil", code: "COMPANY_DESCRIPTION" },
  //         { label: "Kundenbeschreibung", code: "CUSTOMER_DESCRIPTION" },
  //         { label: "Tätigkeiten", code: "ACTIVITIES" },
  //         { label: "Profil", code: "PROFILE" },
  //         { label: "Perspektiven", code: "PERSPECTIVES" },
  //         { label: "Abbinder", code: "FOOTER" }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: "Aktionen (Historie/Wiedervorlagen)",
  //   overviewQuery: "actionTypes",
  //   singleQuery: "actionType",
  //   inputDataType: "ActionTypeInput",
  //   tableNameFunc: e => `${e.nameResubmission || "-"}/${e.nameHistory || "-"}`,
  //   fields: [
  //     { label: "Bezeichung Historie", name: "nameHistory", required: true },
  //     {
  //       label: "Bezeichung Wiedervorlage",
  //       name: "nameResubmission",
  //       required: true
  //     },
  //     {
  //       label: "Verfügbar in",
  //       name: "availableFor",
  //       required: true,
  //       type: "select",
  //       options: [
  //         { label: "Alle", code: "ALL" },
  //         { label: "Stelle/Projekt", code: "VACANCY" },
  //         { label: "Firma", code: "COMPANY" },
  //         { label: "Bewerber", code: "APPLICANT" }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: "Abteilungen",
  //   overviewQuery: "departments",
  //   singleQuery: "department",
  //   inputDataType: "DepartmentInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Standort", name: "branchOffice" },
  //     { label: "Telefonnummer", name: "telephone" },
  //     { label: "E-Mail", name: "email" }
  //   ]
  // },
  // {
  //   name: "Dokumentenvorlagen",
  //   overviewQuery: "documentPresets",
  //   singleQuery: "documentPreset",
  //   inputDataType: "DocumentPresetInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Betreff", name: "subject", required: true },
  //     { label: "Inhalt", name: "content", type: "html", required: true },
  //     {
  //       label: "Art",
  //       name: "type",
  //       required: true,
  //       type: "select",
  //       options: [
  //         { label: "Bewerber", code: "APPLICANT" },
  //         { label: "Projekt", code: "PROJECT" },
  //         { label: "Firma", code: "COMPANY" },
  //         { label: "Akquise", code: "ACQUISITION" }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: "Dokumenten Arten",
  //   overviewQuery: "documentTypes",
  //   singleQuery: "documentType"
  // },
  // {
  //   name: "Benutzer Rollen",
  //   overviewQuery: "userRoles",
  //   singleQuery: "userRole",
  //   inputDataType: "UserRoleInput",
  //   fields: [
  //     { label: "Bezeichung", name: "name", required: true },
  //     { label: "Schlüssel (keine Sonder- oder Leerzeichen)", name: "key" },
  //     {
  //       label: "Berechtigungen",
  //       name: "permissions{name, id}",
  //       required: true,
  //       type: "model",
  //       multiple: true,
  //       gqlQuery: "userPermissions"
  //     }
  //   ]
  // }
  /*,
  {
    name: "Benutzergruppen",
    overviewQuery: "userGroups",
    singleQuery: "userGroup"
  }*/
];
